<template>
    <BreadCrumb PageTitle="Detail des parametres " />
    <ViewParametre/>
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
      import ViewParametre from "@/components/Parametre/ViewParametre.vue";
  
    export default defineComponent({
      name: "ViewParametrePage",
      components: {
        BreadCrumb,
        ViewParametre,
      },
    });
  </script>